import React, { useContext, useEffect } from "react";
import { DashboardHeaderContext } from "../../components/DashboardHeader";
import AdsEditComponent from "../../components/Ads/AdsEditComponent";


export default function AddAnnonce() {
  const { setnavLinks, setpageTitle, setpageNavLink, setalertTitle } = useContext(DashboardHeaderContext)


  useEffect(() => {
    setnavLinks([{ path: "/dashboard/user/mesannonces", label: "adsList" }])
    setpageNavLink({ path: "/dashboard", label: "navigation12.1" })
    setpageTitle("addAd")
    setalertTitle("")
  }, [])


  return (
    <AdsEditComponent />
  )


};

